interface Theme {
    mobileMenuBreakpoint: number;
    mobileTableBreakPoint: number;
    brandColor1: string;
    brandColor2: string;
}

export const defaultTheme: Theme = {
    mobileMenuBreakpoint: 1635,
    mobileTableBreakPoint: 1000,
    brandColor1: "#1ea149",
    brandColor2: "lightgray"
}